/**
 * @generated SignedSource<<b419fa4736f3c95044c3f7a70e6a3ea0>>
 * @relayHash 1305915d09089e21e4c8930da18db3e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c0f565f55b9a0ebf771c0b300219e898f33e4a93a98567019cab857187320741

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareListEmbedAppQuery } from './JiraSoftwareListEmbedAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareListEmbedAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c0f565f55b9a0ebf771c0b300219e898f33e4a93a98567019cab857187320741",
    "metadata": {},
    "name": "JiraSoftwareListEmbedAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
